import { render, staticRenderFns } from "./FontScalerComponent.vue?vue&type=template&id=53e69bc1&scoped=true&"
import script from "./FontScalerComponent.vue?vue&type=script&lang=js&"
export * from "./FontScalerComponent.vue?vue&type=script&lang=js&"
import style0 from "./FontScalerComponent.vue?vue&type=style&index=0&id=53e69bc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e69bc1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
